import PDF from "../../assets/Premium_Cricket.pdf";
import { isMobile } from "react-device-detect";
import { AnimatePresence, motion } from "framer-motion";
const InfoSports = ({ show, setShow }) => {
  const variants = {
    hidden: { y: 750 },
    visible: { y: 0 },
    exit: { y: 750 },
  };
  return (
    <>
      <div
        data-v-d56e9d5a
        className={`s-modal-mask s-fixed s-top-0 s-left-0 s-bottom-0 s-bg-black/50 s-backdrop-blur-[2px] ${isMobile ? "s-w-full" : "s-w-desktop"}`}
        style={{
          "--v622e6b4e": "300",
          "--v302f011b": "100%",
          "--v183a105a": "100vh - 3rem",
        }}
      />
      <div
        data-v-d56e9d5a
        className={`s-modal-container s-fixed s-bottom-0 s-flex-col s-bg-pop-title-bg s-text-global-font-default-light dark:s-text-global-font-default-dark s-px-3px s-rounded-t-5px ${isMobile ? "s-w-full" : "s-w-desktop"}`}
        style={{
          "--v622e6b4e": "300",
          "--v302f011b": "100%",
          "--v183a105a": "100vh - 3rem",
          zIndex: "9999",
        }}
      >
        <AnimatePresence mode="wait">
          {show && (
            <motion.div
              data-v-e15c02a7
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={variants}
              transition={{ duration: 0.4, ease: "easeInOut" }}
            >
              <div
                data-v-d56e9d5a
                className="s-relative s-modal-title s-py-4 s-bg-pop-title-bg"
              >
                <h4
                  data-v-d56e9d5a
                  className="s-mb-0 s-font-bold s-text-17px s-text-center s-text-pop-title-text"
                >
                  Rules of Sportsbook
                </h4>
                <span
                  onClick={() => setShow(false)}
                  data-v-d56e9d5a
                  className="s-icon-close s-absolute s-right-4 s-top-1/2 -s-translate-y-1/2 s-text-pop-title-text s-text-base"
                />
              </div>
              <div data-v-d56e9d5a>
                <div
                  data-v-d56e9d5a
                  className="s-modal-content s-px-24px s-pt-14px s-leading-6 s-rounded-t-3px s-bg-betSlip-light dark:s-bg-black-800 s-overflow-y-scroll"
                >
                  <div className="s--mx-8 s--mt-4 s-grid s-grid-cols-1 s-border-b s-border-black-300 dark:s-border-black-900">
                    <div className="s-py-9px s-pl-22px s-pr-12px s-flex s-justify-between">
                      <div className="s-flex s-items-center">
                        <span className="s-icon-pdf s-mr-2 s-text-18px s-text-black-600" />
                        <span className="s-text-14px">Cricket Rules</span>
                      </div>
                      <div style={{background:"#ffb80c"}} className="s-w-8 s-h-8 s-flex s-justify-center s-items-center s-bg-button-normal s-rounded-4px">
                        <a
                          className="s-inline-flex s-no-underline"
                          href={PDF}
                          download={"cricket"}
                          target="_blank"
                        >
                          <span className="s-icon-download s-text-button-normal s-text-12px" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default InfoSports;
